
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.Body_73ecb7249c47cef3,.Button_7f256d2648497de8,.Disclosure_15b252d4aa1a464a,.Eyebrow_829cf45d36feb82b,.FontContainer_1a37806ea12d9df5,.Headline_416c2ffa02c858dd,.Helper_7a902fe20f2befa7,.LeadBody_464b3e289520dafa,.LinkBody_4932a55a693a347a,.LinkContainer_de5756a67e118a73,.LinkHelper_0483f5813b54fc20,.SectionHeaderOne_3f7e2a5365aa9b3c,.SectionHeaderTwo_0eef1811f575c429,.SmallLabel_1f3ce4a0a43848f0,.Title_76878fdad324a955{font-family:var(--fontFace_f8393c2b9232a949);color:var(--color_6ffb515f9777d070)}.Bold_e25203d3486fb98c{font-weight:unset;font-family:inherit}.Italic_5617f207727b397c{font-style:italic;font-family:inherit}.Superscript_d0b16fbc08e82bfb{font-family:inherit;font-size:.6em;font-weight:400}.Body_73ecb7249c47cef3,.Button_7f256d2648497de8,.Disclosure_15b252d4aa1a464a,.Eyebrow_829cf45d36feb82b,.Headline_416c2ffa02c858dd,.Helper_7a902fe20f2befa7,.LeadBody_464b3e289520dafa,.SectionHeaderOne_3f7e2a5365aa9b3c,.SectionHeaderTwo_0eef1811f575c429,.SmallLabel_1f3ce4a0a43848f0,.Title_76878fdad324a955{margin:0;display:block}.Headline_416c2ffa02c858dd{font-size:28px;font-weight:500;line-height:33.6px;margin-bottom:32px}.Title_76878fdad324a955{font-size:25px;font-weight:500;line-height:30px;margin-bottom:32px}.SectionHeaderOne_3f7e2a5365aa9b3c{font-size:22px;font-weight:500;line-height:25px;margin-bottom:24px}.SectionHeaderTwo_0eef1811f575c429{font-size:16px;font-weight:700;line-height:19.2px;margin-bottom:16px}.LeadBody_464b3e289520dafa{font-size:18px;font-weight:500;line-height:21.6px;margin-bottom:16px}.Body_73ecb7249c47cef3,.LinkBody_4932a55a693a347a,.LinkContainer_de5756a67e118a73{font-size:16px;font-weight:400;line-height:20.8px;margin-bottom:16px}.Helper_7a902fe20f2befa7,.LinkHelper_0483f5813b54fc20{font-size:14px;font-weight:400;line-height:18.2px;margin-bottom:16px}.Disclosure_15b252d4aa1a464a{font-size:12px;font-weight:400;line-height:16.8px;margin-bottom:16px}.Disclosure_15b252d4aa1a464a .LinkContainer_de5756a67e118a73{font-size:12px}.SmallLabel_1f3ce4a0a43848f0{font-size:10px;font-weight:500;line-height:12px}.Button_7f256d2648497de8{font-size:14px;font-weight:500;line-height:16px;text-transform:uppercase}.Eyebrow_829cf45d36feb82b{font-size:12px;font-weight:700;line-height:14px;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px}.LinkBody_4932a55a693a347a{text-decoration:none;cursor:pointer;display:inline-block}.LinkContainer_de5756a67e118a73,.LinkHelper_0483f5813b54fc20{text-decoration:underline;cursor:pointer;display:inline-block}.LinkBody_4932a55a693a347a:active,.LinkBody_4932a55a693a347a:focus,.LinkBody_4932a55a693a347a:hover,.LinkContainer_de5756a67e118a73:active,.LinkContainer_de5756a67e118a73:focus,.LinkContainer_de5756a67e118a73:hover,.LinkHelper_0483f5813b54fc20:active,.LinkHelper_0483f5813b54fc20:focus,.LinkHelper_0483f5813b54fc20:hover{text-decoration:none;color:var(--activeColor_c4dbde6f79f5b6d5)}.Body_73ecb7249c47cef3 .LinkBody_4932a55a693a347a,.Body_73ecb7249c47cef3 .LinkContainer_de5756a67e118a73,.Disclosure_15b252d4aa1a464a .LinkContainer_de5756a67e118a73,.Headline_416c2ffa02c858dd .LinkContainer_de5756a67e118a73,.Helper_7a902fe20f2befa7 .LinkContainer_de5756a67e118a73,.Helper_7a902fe20f2befa7 .LinkHelper_0483f5813b54fc20,.LeadBody_464b3e289520dafa .LinkContainer_de5756a67e118a73,.LinkBody_4932a55a693a347a .LinkContainer_de5756a67e118a73,.LinkHelper_0483f5813b54fc20 .LinkContainer_de5756a67e118a73,.SectionHeaderOne_3f7e2a5365aa9b3c .LinkContainer_de5756a67e118a73,.SmallLabel_1f3ce4a0a43848f0 .LinkContainer_de5756a67e118a73,.Title_76878fdad324a955 .LinkContainer_de5756a67e118a73{display:inline}.Body_73ecb7249c47cef3 .Bold_e25203d3486fb98c,.Disclosure_15b252d4aa1a464a .Bold_e25203d3486fb98c,.Headline_416c2ffa02c858dd .Bold_e25203d3486fb98c,.Helper_7a902fe20f2befa7 .Bold_e25203d3486fb98c,.LeadBody_464b3e289520dafa .Bold_e25203d3486fb98c,.LinkBody_4932a55a693a347a .Bold_e25203d3486fb98c,.LinkContainer_de5756a67e118a73 .Bold_e25203d3486fb98c,.LinkHelper_0483f5813b54fc20 .Bold_e25203d3486fb98c,.SectionHeaderOne_3f7e2a5365aa9b3c .Bold_e25203d3486fb98c,.SmallLabel_1f3ce4a0a43848f0 .Bold_e25203d3486fb98c,.Title_76878fdad324a955 .Bold_e25203d3486fb98c{font-weight:700}@media screen and (min-width:600px){.Headline_416c2ffa02c858dd{font-size:44px;font-weight:300;line-height:52.8px}.Headline_416c2ffa02c858dd .Bold_e25203d3486fb98c{font-weight:500}.Title_76878fdad324a955{font-size:28px;line-height:33.6px}}`;
styleInject(_css)

/** Headline Props */
export type HeadlineCCM = {
  /** Headline Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** Headline Modifier Flags */
  // No modifiers classes found
};
/** Base Headline component */
export const Headline: ComponentCreator<HeadlineCCM> = createComponentCreator({
  "name": "Headline",
  "base": "Headline_416c2ffa02c858dd",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** Title Props */
export type TitleCCM = {
  /** Title Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** Title Modifier Flags */
  // No modifiers classes found
};
/** Base Title component */
export const Title: ComponentCreator<TitleCCM> = createComponentCreator({
  "name": "Title",
  "base": "Title_76878fdad324a955",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** SectionHeaderOne Props */
export type SectionHeaderOneCCM = {
  /** SectionHeaderOne Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** SectionHeaderOne Modifier Flags */
  // No modifiers classes found
};
/** Base SectionHeaderOne component */
export const SectionHeaderOne: ComponentCreator<SectionHeaderOneCCM> = createComponentCreator({
  "name": "SectionHeaderOne",
  "base": "SectionHeaderOne_3f7e2a5365aa9b3c",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** SectionHeaderTwo Props */
export type SectionHeaderTwoCCM = {
  /** SectionHeaderTwo Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** SectionHeaderTwo Modifier Flags */
  // No modifiers classes found
};
/** Base SectionHeaderTwo component */
export const SectionHeaderTwo: ComponentCreator<SectionHeaderTwoCCM> = createComponentCreator({
  "name": "SectionHeaderTwo",
  "base": "SectionHeaderTwo_0eef1811f575c429",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** LeadBody Props */
export type LeadBodyCCM = {
  /** LeadBody Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** LeadBody Modifier Flags */
  // No modifiers classes found
};
/** Base LeadBody component */
export const LeadBody: ComponentCreator<LeadBodyCCM> = createComponentCreator({
  "name": "LeadBody",
  "base": "LeadBody_464b3e289520dafa",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** Body Props */
export type BodyCCM = {
  /** Body Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** Body Modifier Flags */
  // No modifiers classes found
};
/** Base Body component */
export const Body: ComponentCreator<BodyCCM> = createComponentCreator({
  "name": "Body",
  "base": "Body_73ecb7249c47cef3",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** LinkBody Props */
export type LinkBodyCCM = {
  /** LinkBody Component Custom Properties */
  '$fontFace': string;
  '$color': string;
  '$activeColor': string;

  /** LinkBody Modifier Flags */
  // No modifiers classes found
};
/** Base LinkBody component */
export const LinkBody: ComponentCreator<LinkBodyCCM> = createComponentCreator({
  "name": "LinkBody",
  "base": "LinkBody_4932a55a693a347a",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070",
    "$activeColor": "--activeColor_c4dbde6f79f5b6d5"
  },
  "mod": {}
});


/** Helper Props */
export type HelperCCM = {
  /** Helper Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** Helper Modifier Flags */
  // No modifiers classes found
};
/** Base Helper component */
export const Helper: ComponentCreator<HelperCCM> = createComponentCreator({
  "name": "Helper",
  "base": "Helper_7a902fe20f2befa7",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** LinkHelper Props */
export type LinkHelperCCM = {
  /** LinkHelper Component Custom Properties */
  '$fontFace': string;
  '$color': string;
  '$activeColor': string;

  /** LinkHelper Modifier Flags */
  // No modifiers classes found
};
/** Base LinkHelper component */
export const LinkHelper: ComponentCreator<LinkHelperCCM> = createComponentCreator({
  "name": "LinkHelper",
  "base": "LinkHelper_0483f5813b54fc20",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070",
    "$activeColor": "--activeColor_c4dbde6f79f5b6d5"
  },
  "mod": {}
});


/** Disclosure Props */
export type DisclosureCCM = {
  /** Disclosure Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** Disclosure Modifier Flags */
  // No modifiers classes found
};
/** Base Disclosure component */
export const Disclosure: ComponentCreator<DisclosureCCM> = createComponentCreator({
  "name": "Disclosure",
  "base": "Disclosure_15b252d4aa1a464a",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** SmallLabel Props */
export type SmallLabelCCM = {
  /** SmallLabel Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** SmallLabel Modifier Flags */
  // No modifiers classes found
};
/** Base SmallLabel component */
export const SmallLabel: ComponentCreator<SmallLabelCCM> = createComponentCreator({
  "name": "SmallLabel",
  "base": "SmallLabel_1f3ce4a0a43848f0",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** Button Props */
export type ButtonCCM = {
  /** Button Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** Button Modifier Flags */
  // No modifiers classes found
};
/** Base Button component */
export const Button: ComponentCreator<ButtonCCM> = createComponentCreator({
  "name": "Button",
  "base": "Button_7f256d2648497de8",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** Eyebrow Props */
export type EyebrowCCM = {
  /** Eyebrow Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** Eyebrow Modifier Flags */
  // No modifiers classes found
};
/** Base Eyebrow component */
export const Eyebrow: ComponentCreator<EyebrowCCM> = createComponentCreator({
  "name": "Eyebrow",
  "base": "Eyebrow_829cf45d36feb82b",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** LinkContainer Props */
export type LinkContainerCCM = {
  /** LinkContainer Component Custom Properties */
  '$fontFace': string;
  '$color': string;
  '$activeColor': string;

  /** LinkContainer Modifier Flags */
  // No modifiers classes found
};
/** Base LinkContainer component */
export const LinkContainer: ComponentCreator<LinkContainerCCM> = createComponentCreator({
  "name": "LinkContainer",
  "base": "LinkContainer_de5756a67e118a73",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070",
    "$activeColor": "--activeColor_c4dbde6f79f5b6d5"
  },
  "mod": {}
});


/** FontContainer Props */
export type FontContainerCCM = {
  /** FontContainer Component Custom Properties */
  '$fontFace': string;
  '$color': string;

  /** FontContainer Modifier Flags */
  // No modifiers classes found
};
/** Base FontContainer component */
export const FontContainer: ComponentCreator<FontContainerCCM> = createComponentCreator({
  "name": "FontContainer",
  "base": "FontContainer_1a37806ea12d9df5",
  "prop": {
    "$fontFace": "--fontFace_f8393c2b9232a949",
    "$color": "--color_6ffb515f9777d070"
  },
  "mod": {}
});


/** Bold Props */
export type BoldCCM = {
  /** Bold Component Custom Properties */
  // No custom properties found

  /** Bold Modifier Flags */
  // No modifiers classes found
};
/** Base Bold component */
export const Bold: ComponentCreator<BoldCCM> = createComponentCreator({
  "name": "Bold",
  "base": "Bold_e25203d3486fb98c",
  "prop": {},
  "mod": {}
});


/** Italic Props */
export type ItalicCCM = {
  /** Italic Component Custom Properties */
  // No custom properties found

  /** Italic Modifier Flags */
  // No modifiers classes found
};
/** Base Italic component */
export const Italic: ComponentCreator<ItalicCCM> = createComponentCreator({
  "name": "Italic",
  "base": "Italic_5617f207727b397c",
  "prop": {},
  "mod": {}
});


/** Superscript Props */
export type SuperscriptCCM = {
  /** Superscript Component Custom Properties */
  // No custom properties found

  /** Superscript Modifier Flags */
  // No modifiers classes found
};
/** Base Superscript component */
export const Superscript: ComponentCreator<SuperscriptCCM> = createComponentCreator({
  "name": "Superscript",
  "base": "Superscript_d0b16fbc08e82bfb",
  "prop": {},
  "mod": {}
});

